var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'font-family-selector d-flex justify-center font-weight-bold align-center font-size-14 mr-3 px-3 py-2 ' +
        (_vm.active ? 'font-family-active' : 'font-family-non-active'),style:(`font-family: ${_vm.font_family.fontFamilyValue} !important`),on:{"click":_vm.setConfigs}},[_vm._v(" "+_vm._s(_vm.font_family.fontFamilyName)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }